import TransactionResource from './transaction-resouce';
import { observable, action } from 'mobx';
import Cons from '../../isomorphic/cons';
import Notifications from '../utils/notification-helper';
import GooglePlacesHelper from '../utils/google-places-helper';
import moment from 'moment';

export default class TransactionStore {
    @observable isLoading = false;

    constructor(appStore) {
        this.appStore = appStore;
        this.transactionResource = new TransactionResource();
    }

    getTransactionsById(transactionId) {
        return this.transactionResource.getById(this.appStore.authStore.getAccessToken(), transactionId);
    }

    @action
    createNewTransaction(transactionFields) {
        const newTransaction = this.convertFieldsToNewTransaction(transactionFields);
        this.isLoading = true;
        this.transactionResource
            .createNewTransaction(this.appStore.authStore.getAccessToken(), newTransaction)
            .then((result) => {
                const transactionId = result.transaction.TransactionId;
                return this.appStore.tcFileStore.createFileFromTransaction(transactionId, {
                    typeOfSale: transactionFields.typeOfSale ? transactionFields.typeOfSale : null,
                    status: Cons.fileStatuses['Incomplete'],
                    fileSubmissionDate: moment(new Date()),
                    origin: 'Transaction',
                });
            })
            .then(() => {
                this.appStore.viewStore.openFileDetailPageForNew({ tcFileId: 'new' });
                this.isLoading = false;
            })
            .catch((err) => {
                var errorMessage = 'Error creating new transaction.';
                if (err.response && err.response.statusCode === 409) {
                    // Conflict
                    errorMessage = errorMessage + ' An existing transaction with the same address exists.'; // TODO - too much strings
                }
                Notifications.ToastError(errorMessage);
                console.log(err);
                this.isLoading = false;
            });
    }

    convertFieldsToNewTransaction(transactionFields) {
        const newTransaction = {
            StreetNumber: transactionFields.address1,
            StreetDirection: transactionFields.direction,
            StreetAddress: transactionFields.address2,
            City: transactionFields.city,
            State: transactionFields.state,
            County: transactionFields.county,
            Zip: transactionFields.zip,
            AgentId: transactionFields.agent[0] ? transactionFields.agent[0].agentContactId : undefined,
            AgentSubscriberId: transactionFields.agent[0] ? transactionFields.agent[0].subscriberId : undefined,
            EscrowClosingDate: transactionFields.estimatedCloseDate,
            UnitNumber: transactionFields.unitNum,
        };

        return newTransaction;
    }
}



// WEBPACK FOOTER //
// ./src/transaction/transaction-store.js